// Condição de saúde / lesão.
//
// Duas opções e, no "Sim", o campo livre — é o § 3 ("'Sim, quero descrever'
// abre a pergunta seguinte com o campo de texto (mesmo `setNeedsButton`)").
// Payload de sempre: SPECIAL_CARE (boolean) + SPECIAL_CARE_DETAILS (texto).

import React, { useEffect, useRef, useState } from "react";

import { Campo, Opcoes } from "../widgets/Widgets.jsx";
import s from "./ChipsComOutro.module.scss";

const OPCOES = [
  { value: "no", label: "Não, tudo certo" },
  { value: "yes", label: "Sim, quero descrever" },
];

const StepSpecialCare = ({ setCanProceed, setStepData, setNeedsButton }) => {
  const [opcao, setOpcao] = useState("");
  const [detalhes, setDetalhes] = useState("");
  const campoRef = useRef(null);

  useEffect(() => {
    const respondeu = opcao === "yes" || opcao === "no";
    const precisaTexto = opcao === "yes";
    const valido = respondeu && (!precisaTexto || detalhes.trim().length > 0);

    setCanProceed(valido);
    if (!respondeu) {
      setStepData(null);
      return;
    }
    setStepData({
      SPECIAL_CARE: opcao === "yes",
      SPECIAL_CARE_DETAILS: opcao === "yes" ? detalhes.trim() : "",
    });
  }, [opcao, detalhes, setCanProceed, setStepData]);

  const escolher = (valor) => {
    setOpcao(valor);
    if (valor === "no") {
      setDetalhes("");
      setNeedsButton?.(false);
      return;
    }
    // "Sim" tira o auto-advance do caminho: sem isto o fluxo pularia a
    // pergunta antes de a pessoa escrever a primeira letra.
    setNeedsButton?.(true);
    requestAnimationFrame(() => campoRef.current?.focus());
  };

  return (
    <div className={s.bloco}>
      <Opcoes opcoes={OPCOES} valor={opcao} onSelecionar={escolher} numeradas={false} />
      {opcao === "yes" && (
        <Campo
          ref={campoRef}
          valor={detalhes}
          onChange={setDetalhes}
          placeholder="Ex.: dor no joelho, hipertensão, hérnia de disco…"
          multilinha
        />
      )}
    </div>
  );
};

export default StepSpecialCare;
